import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import stopImmediatePropagation from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'
import { tapDown, tapUp } from '@mailobj-browser/front/js/events/listeners/builtins/tap.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import capture from '@mailobj-browser/front/js/events/options/capture.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import animationEnd from '@mailobj-browser/front/js/events/types/animationEnd.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { close, isOpen } from '#utilities/js/lightboxes/menus/menu.js'
import { modifiers } from '../../styles.js'

let last = null

const onAnimationEnd = object(listener, {
  type: animationEnd,
  passive,
  task: (
    backdrop
  ) => {
    backdrop.classList.remove(modifiers.animate.shake)
  }
})

export const onTapDown = object(tapDown, {
  capture,
  passive,
  task: (
    backdrop,
    { target }
  ) => {
    if (backdrop === target) {
      last = backdrop
    }
  }
})

export const onTapUp = object(tapUp, {
  capture,
  task: (
    backdrop,
    event
  ) => {
    const { target } = event
    const { dataset, parentNode } = backdrop
    const { confirm: confirmMessage } = dataset

    if (target !== backdrop) {
      last = null

      return
    }

    preventDefault(event)
    stopImmediatePropagation(event)

    if (isOpen()) {
      last = null
      close()

      return
    }

    if (!confirmMessage && last !== null && backdrop.classList.contains(modifiers.has.transition_end)) {
      backdrop.classList.add(modifiers.animate.shake)
    }

    const anchor = one('[data-contract~="modal.close"]', parentNode)

    if (anchor && last === backdrop) {
      anchor.click()
    }

    last = null
  }
})

export default backdrop => {
  onTapUp.listen(backdrop)
  onTapDown.listen(backdrop)

  if (Object.hasOwn(globalThis, 'onanimationend')) {
    backdrop.classList.add(modifiers.has.transition_end)
    onAnimationEnd.listen(backdrop)
  }
}